import { gql } from '@apollo/client';

const GET_UNREAD_USER_NOTIFICATIONS_COUNT = gql`
  query GetUnreadUserNotificationCount {
    unreadUserNotificationCount
  }
`;

export default GET_UNREAD_USER_NOTIFICATIONS_COUNT;
